import { render, staticRenderFns } from "./Limite.vue?vue&type=template&id=7b685489&scoped=true"
import script from "./Limite.vue?vue&type=script&lang=js"
export * from "./Limite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b685489",
  null
  
)

export default component.exports